import React from 'react'
import PrivacyPolicy from './PrivacyPolicy'
import Footer from '../Footer/Footer'

const PrivacyPolicyPage = () => {
  return (
    <>
    <PrivacyPolicy/>
    <Footer/>
    </>
  )
}

export default PrivacyPolicyPage